module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"warning-msg":"No reports available."},"ar":{"warning-msg":"لا توجد تقارير متاحة."}}')
  delete Component.options._Ctor
}
